module.exports = __webpack_public_path__ + "media/binanshous_day.79934858.wav";